import { getState } from '~src/state';
import { mm2px, cm2px } from '~src/utils/units';
import { updateSnapColor, updateSnapThreshold } from './constants';

// Get snap settings at runtime to avoid circular dependency
export const getSnapSettings = () => {
  if (window.editorConfig && window.editorConfig.snapSettings) {
    updateSnapColor(
      window.editorConfig.snapSettings.snapIndicatorColor || '#ff6b00'
    );
    updateSnapThreshold(
      window.editorConfig.snapSettings.guidelineSnapThreshold || 10
    );
    return window.editorConfig.snapSettings;
  }
  return {
    enableCenterSnapping: true,
    enableEdgeSnapping: true,
  };
};

// Get current DPI from format or use default
export const getCurrentDPI = () => {
  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');
  const dpi =
    format && format.dpi
      ? format.dpi
      : formatDefault && formatDefault.dpi
      ? formatDefault.dpi
      : 300;
  return dpi;
};

// Dynamic ruler mark intervals based on unit
export const getRulerMarkIntervals = (rulerUnit) => {
  const dpi = getCurrentDPI();

  if (rulerUnit === 'mm') {
    const mmInPx = mm2px(1, dpi);
    return {
      minor: mmInPx, // Every 1mm
      medium: mmInPx * 5, // Every 5mm
      major: mmInPx * 10, // Every 10mm (1cm)
    };
  } else if (rulerUnit === 'cm') {
    const cmInPx = cm2px(1, dpi);
    return {
      minor: cmInPx / 10, // Every 1mm
      medium: cmInPx / 2, // Every 5mm
      major: cmInPx, // Every 1cm
    };
  } else {
    // Pixels (default)
    return {
      minor: 10, // Small marks every 10 pixels
      medium: 50, // Medium marks every 50 pixels
      major: 100, // Major marks every 100 pixels
    };
  }
};
